<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
          label="会员姓名"
        >
          <el-input
            v-model="searchForm.legal"
            placeholder="会员姓名"
            style="width: 100px;"
          />
        </el-form-item>
        <el-form-item
                label="电话号码"
        >
          <el-input
                  v-model="searchForm.userCode"
                  placeholder="电话号码"
                  style="width: 120px;"
          />
        </el-form-item>

        <el-form-item>
          <el-date-picker
                  v-model="dateRange"
                  :picker-options="pickerOptions"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"    width="150">

          </el-date-picker>

        </el-form-item>

        <el-form-item
                label="用户编号"
        >
          <el-input
                  v-model="searchForm.user_agentid"
                  placeholder="用户编号"
                  style="width: 120px;"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="用户编号"
      >
        <template slot-scope="scope">
          {{scope.row.agentid}}
        </template>
      </el-table-column>

      <el-table-column
        label="微信呢称"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.userName}}
        </template>
      </el-table-column>
      <el-table-column
              label="微信图像"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.avatarUrl!=null && scope.row.avatarUrl!=''">
            <img :src= "getImgUrl3(scope.row)" style="width: 100px;height: 100px; "/>
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="账号类型"
      >
        <template slot-scope="scope">

            <div v-if="scope.row.dl_type=='-1'">
              平台
            </div>
            <div v-else-if="scope.row.dl_type=='0'">
              全国代理
            </div>
            <div v-else-if="scope.row.dl_type=='1'">
              运营商
            </div>
            <div v-else-if="scope.row.dl_type=='2'">
              服务商
            </div>
            <div v-else-if="scope.row.dl_type=='5'">
              运营中心
            </div>


        </template>
      </el-table-column>
      <el-table-column
        label="会员姓名"
      >
        <template slot-scope="scope">
          {{scope.row.legal}}
        </template>
      </el-table-column>

        <el-table-column
                label="团队代理"
        >
            <template slot-scope="scope">
                {{scope.row.cny_amt}}
            </template>
        </el-table-column>
      <el-table-column
              label="团队商家"
      >
        <template slot-scope="scope">
          {{scope.row.agentaccount}}
        </template>
      </el-table-column>
      <!--
      <el-table-column
              label="拼团补贴(元)"
      >
        <template slot-scope="scope">
          {{scope.row.agent_face}}
        </template>
      </el-table-column>
      <el-table-column
              label="拼团积分"
      >
        <template slot-scope="scope">
          {{scope.row.idcards_hand}}
        </template>
      </el-table-column>-->
      <el-table-column
        label="手机号"
      >
        <template slot-scope="scope">
          {{scope.row.mobileNo}}
        </template>
      </el-table-column>
      <el-table-column
              label="注册时间"
      >
        <template slot-scope="scope">
          {{scope.row.create_times}}
        </template>
      </el-table-column>

      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="300"
      >
        <template slot-scope="scope">
          <el-button type="primary" plain  size="mini"    @click="openEditForm(scope.row)">查看团队商家明细</el-button>
          <el-button type="primary" plain  size="mini"    @click="openUpgradeForm(scope.row)">查看团队代理明细</el-button>
        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <viewjymx-form
            :agentid="agentid"
            v-model="editFormVisible"
            @submit="getTableData"
    />

    <upgrade-form
            :agentid="agentid"
            v-model="upgradeFormVisible"
            @submit="getTableData"
    />

  </d2-container>
</template>
<script>
import * as memberService from "@/api/sys/member";
import util from '@/libs/util.js'
import viewjymxForm from "./viewjymxForm";
import upgradeForm from "./upgradeForm";
export default {
  name: "MembergglPage",
  components: { viewjymxForm,upgradeForm },
  data() {
    return {
      searchForm: {
          fxtel: "",
          legal: "",
        member_id: "",
        user_agentid: "",
          userCode: ""
      },
      loading: false,
        is_agentid:util.cookies.get('agentid'),
      tableData: [],
      multipleSelection: [],
        dateRange: [],
        pickerOptions:{},
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        oneclass: {},
        pickerValue2:'',
        pickerValue3:'',
        agentid:'',
      upgradeFormVisible:false,
      editFormVisible: false
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
      dateConversion(value) {
          if (value != null && value != "") {
              var d = new Date(value);
              //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
              var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
              console.info("===========date=========" + date);
              return date;
          }else{
              return "";
          }
      },
    getImgUrl3(row){
      var good_url=row.avatarUrl;
      if(good_url.match(",")){
        var str = good_url.split(',');
        good_url=str[1];
      }

      return good_url;
    },
    getTableData() {
      if(this.dateRange==null){
        this.dateRange="";
      }
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          dl_type: util.cookies.get('dl_type'),
          xt_id: util.cookies.get('xt_id'),
          agentid: util.cookies.get('agentid'),
          startTime:this.dateConversion(this.dateRange[0]),
          endTime:this.dateConversion(this.dateRange[1]),
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        memberService.getDlPageList(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
    handleSearchFormSubmit() {
        this.page.current=1;
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    openUpgradeForm(oneclass) {
      this.agentid = oneclass.agentid;
      this.upgradeFormVisible = true;
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
    openEditForm(oneclass) {
      this.editFormVisible = true;
        this.agentid = oneclass.agentid;

    },
    batchDel() {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          memberService
          .delMemberglBath({
            ids: JSON.stringify(this.multipleSelection.map(s => s.userId))
          })
          .then(() => {
            this.getTableData();
          });
      });
    },
    del(oneclass) {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          memberService.delMembergl({userId:oneclass.userId,agentid:oneclass.agentid}).then(() => {
          this.getTableData();
        });
      });
    }
  }
};
</script>
